import { useDashboardGlobalContext } from '@/dashboards/providers/dashboardGlobalContext';
import { formatUrlDate } from '@/utils/dateUtils';
import { capitalizeFirstLetter } from '@/utils/stringUtils';
import { InfoColumn, Typography } from '@analytical-alley/ui';
import { ReactNode } from 'react';

const Label = ({
    children,
    tooltip,
}: {
    children: React.ReactNode;
    tooltip?: ReactNode;
}) => <Typography variant="bodyM" tooltip={tooltip}>{children}</Typography>;

const Value = ({
    children,
    tooltip,
}: {
    children: React.ReactNode;
    tooltip?: ReactNode;
}) => (
    <Typography variant="bodyM" tooltip={tooltip}>
        {children}
    </Typography>
);

function getPeriodicityTooltip(interval: string | undefined) {
    if (interval === 'daily') {
        return 'This model measures the effect of daily media spending and other factors on daily KPI.';
    }

    if (interval === 'weekly') {
        return 'This model measures the effect of aggregated weekly media spending and other factors on weekly KPI.';
    }

    return '';
}

export const ModelDataMetrics = () => {
    const {
        project: { kpiDefinition, interval },
        startDate,
        endDate,
    } = useDashboardGlobalContext();

    const formattedStartDate = formatUrlDate(startDate);
    const formattedEndDate = formatUrlDate(endDate);

    const periodValue =
        formattedStartDate && formattedEndDate
            ? `${formattedStartDate} - ${formattedEndDate}`
            : '-';

    return (
        <div className="font-mono dark:text-white">
            <InfoColumn>
                <Label tooltip="The type of a performance indicator used in this model.">
                    KPI:
                </Label>
                <Value>{kpiDefinition || '-'}</Value>
                <Label tooltip="Modelling period start and end date.">
                    Period:
                </Label>
                <Value>{periodValue}</Value>
                <Label tooltip={getPeriodicityTooltip(interval)}>
                    Periodicity:
                </Label>
                <Value tooltip={getPeriodicityTooltip(interval)}>
                    {interval ? capitalizeFirstLetter(interval) : '-'}
                </Value>
            </InfoColumn>
        </div>
    );
};
